import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { InstagramStoryFooter } from '../footers/InstagramStoryFooter'
import { InstagramStoryHeader } from '../headers/InstagramStoryHeader'
import { styles } from './styles'

type OverlayProps = {
  accountImage: AssetReference | null
  accountName: string
  allowReplies: boolean
  allowSharing: boolean
  instagramCollab: boolean
  collabAccount: string
  cta?: string
  ctaUrl?: string
  currentIndex: number
  modulesLength: number
  postType: string
}

export const Overlay: React.FC<OverlayProps> = ({
  accountImage,
  accountName,
  allowReplies,
  allowSharing,
  instagramCollab,
  collabAccount,
  cta,
  ctaUrl,
  currentIndex,
  modulesLength,
  postType,
}) => (
  <div
    css={styles.overlayStyles}
    className={kuiperClassNames('instagram-story-overlay')}
  >
    <InstagramStoryHeader
      modulesLength={modulesLength}
      accountImage={accountImage}
      accountName={accountName}
      collabAccount={collabAccount}
      instagramCollab={instagramCollab}
      currentIndex={currentIndex}
      postType={postType}
    />
    <InstagramStoryFooter
      allowReplies={allowReplies}
      allowSharing={allowSharing}
      cta={cta}
      ctaUrl={ctaUrl}
    />
  </div>
)
